import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const goldAndSliverGraphApi = createAsyncThunk(
  "goldAndSilverGraph",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/augmont/historicalData`,payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const goldAndSilverGraphSlice = createSlice({
  name: "goldAndSilverGraph",
  initialState: {
    data: [],
    errors: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(goldAndSliverGraphApi.pending, (state) => {
        state.status = "loading";
        state.errors = [];
      })
      .addCase(goldAndSliverGraphApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = "idle";
      })
      .addCase(goldAndSliverGraphApi.rejected, (state, action) => {
        state.errors.push(action.payload);
        state.status = "idle";
      });
  },
});

export default goldAndSilverGraphSlice.reducer;
